<template>
  <div class="swapDetail">
    <div class="van-dialog__header">
      <div class="text">{{ $t('lang.swap27') }}</div>
      <div class="cancel"
           @click="handleClose"></div>
    </div>
    <div class="btContent">
      <div class="tokenInfo">
        <div class="leftItem">
          <img class="tokenImg"
               :src="fromCur.logoURI"
               alt="" />
          <div class="input">{{ swapDetail.fromInput }}</div>
        </div>
        <div class="symbol">{{ fromCur.symbol }}</div>
      </div>
      <img class="down"
           src="@/assets/img/opposite.png"
           alt="" />
      <div class="tokenInfo">
        <div class="leftItem">
          <img class="tokenImg"
               :src="toCur.logoURI"
               alt="" />
          <div class="input">{{ swapDetail.toInput }}</div>
        </div>
        <div class="symbol">{{ toCur.symbol }}</div>
      </div>
      <div class="tip"
           v-if="swapDetail.inputSource === 'from'">
        {{ $t('lang.swap28', { inputOutMin: swapDetail.inputOutMin, symbol: toCur.symbol }) }}
      </div>
      <div class="tip"
           v-else>{{ $t('lang.swap29', { inputInMax: swapDetail.inputInMax, symbol: fromCur.symbol }) }}</div>

      <div class="wrap box_bg_2">
        <div class="wrapItem"
             @click="changePriceDirection">
          <div>{{ $t('lang.swap7') }}</div>
          <div class="priceItem">
            <div v-if="priceDirection">1{{ toCur.symbol }} = {{ swapDetail.price }} {{ fromCur.symbol }}</div>
            <div v-else>1{{ fromCur.symbol }} = {{ opppsitePrice }} {{ toCur.symbol }}</div>
            <van-image class="opppsite"
                       :src="require('@/assets/img/opposites.png')" />
          </div>
        </div>
        <div class="wrapItem"
             v-if="swapDetail.inputSource === 'from'">
          <div>{{ $t('lang.swap30') }}</div>
          <div class="priceItem">{{ swapDetail.inputOutMin }} {{ toCur.symbol }}</div>
        </div>
        <div class="wrapItem"
             v-else>
          <div>{{ $t('lang.swap31') }}</div>
          <div class="priceItem">{{ swapDetail.inputInMax }} {{ fromCur.symbol }}</div>
        </div>
        <!-- <div class="wrapItem">
          <div>流动性供应商费用</div>
          <div>{{ swapDetail.fee }} {{ fromCur.symbol }}</div>
        </div> -->
      </div>
      <van-button type="primary"
                  class="confirmBtn"
                  @click="handleConfirm">{{ $t('lang.swap27') }}</van-button>
    </div>
  </div>
</template>

<script>
import { accDiv, significantDigits } from '@/utils/format.js';

export default {
  name: 'swapDetail',
  props: ['fromCur', 'toCur', 'swapDetail'],
  data () {
    return {
      priceDirection: true,
      opppsitePrice: '',
    };
  },
  mounted () { },
  methods: {
    handleConfirm () {
      this.$emit('listenConfirm');
    },
    handleClose () {
      this.$emit('listenClose');
    },
    changePriceDirection () {
      this.priceDirection = !this.priceDirection;
      this.opppsitePrice = significantDigits(accDiv(1, this.swapDetail.price));
    },
    significantDigits,
  },
};
</script>

<style lang="less" scoped>
.swapDetail {
  // width: 350px;
    background: linear-gradient(143.12deg, rgba(78, 29, 5, 0.42) 0%, rgba(8, 3, 2, 1) 100%);

  .van-dialog__header {
    text-align: center;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: bold;
    font-size: 14px;
    color: #FFF;
    border-bottom: 1px solid #f1f4f9;
    padding: 20px 0;
    margin: 0 20px;
    .cancel {
      width: 16px;
      height: 16px;
      background-image: url('~@/assets/img/cancel.png');
      background-size: contain;
      background-repeat: no-repeat;
      cursor: pointer;
    }
  }
  .btContent {
    width: 100%;

    padding: 0 16px;
  }
  .down {
    display: block;
    height: 44px;
    width: 44px;
    margin: 0 auto;
  }
  .tokenInfo {
    display: flex;
    align-items: center;
    // justify-content: space-between;

    color: #FFF;
    font-size: 16px;
    font-weight: bold;
    padding: 12px 0;
    .leftItem {
      display: flex;
      align-items: center;
      .input {
        margin-left: 5px;
      }
      .tokenImg {
        height: 30px;
        width: 30px;
        border-radius: 50%;
      }
    }
    .symbol {
      margin-left: 10px;
    }
  }
  .tip {
    font-weight: 700;
    font-size: 12px;
    line-height: 20px;
    color: #FFF;
    margin-top: 20px;
  }
  .wrap {
    background: #f1f4f9;
    border-radius: 16px;
    font-size: 14px;
    padding: 1px 16px 20px;
    margin-top: 20px;
    .wrapItem {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      color: #999999;
      margin-top: 20px;
      .priceItem {
        display: flex;
        align-items: center;
        color: #FFF;
        font-weight: bold;
        .opppsite {
          height: 20px;
          width: 20px;
          margin-left: 4px;
        }
      }
    }
  }
  .confirmBtn {
    width: 100%;
    margin: 22px 0;
    font-size: 16px;
    font-weight: bold;
    padding: 26px 0;
    border-radius: 110px;
    background: #E06029;
  }
    /deep/.van-button--primary {
  border: none !important;
}
}
</style>
